import {faClock} from "@fortawesome/free-regular-svg-icons"
import {faCircleCheck} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import styles from "./index.module.scss"

interface ReleaseNoteMetaData {
  title: string
  updateTime: string
  imgUrl: string
  description: string
  highlights: string[]
}

interface ReleaseNoteBlockProps {
  meta: ReleaseNoteMetaData
}

export const ReleaseNoteBlock = (props: ReleaseNoteBlockProps) => {
  const {title, updateTime, imgUrl, description, highlights} = props.meta
  return (
    <div className={styles.UpdateBlock}>
      <div className={styles.Title}>{title}</div>
      <div className={styles.UpdateTime}>
        <FontAwesomeIcon icon={faClock}/>
        <div>{updateTime}</div>
      </div>
      <img src={imgUrl} alt={title} className={styles.Image}/>
      <div className={styles.DescriptionHeader}>Description</div>
      <div className={styles.Description}>{description}</div>
      <div className={styles.HighlightHeader}>Highlights</div>
      <div className={styles.HighlightList}>
        {
          highlights.map((h: string) => (
            <div className={styles.Highlight} key={h}>
              <FontAwesomeIcon icon={faCircleCheck}/>
              <div>{h}</div>
            </div>
          ))
        }
      </div>
    </div>
  )
}
